import React from 'react'
import { Flex, Tag } from 'antd'
import { t } from 'i18next'

export function AppointmentStateTag ({ appointment, state }) {
  const appointmentState = state || appointment?.state
  return (
    <Tag color={t(`Admin.Appointment.stateColor.${appointmentState}`)} variant='solid' style={{ width: 'fit-content' }}>
      {t(`Admin.Appointment.state.${appointmentState}`)}
    </Tag>
  )
}

export function BoxStateTag ({ box, state }) {
  const boxState = state || box?.state
  return (
    <Tag color={t(`Admin.Box.stateColor.${boxState}`)} style={{ width: 'fit-content' }}>
      {t(`Admin.Box.state.${boxState}`)}
    </Tag>
  )
}
export function ConsultationStateTag ({ appointment }) {
  const consultationState = appointment?.consultation_done
  return (
    <>
      {appointment.type === 'PatientAppointment' &&
        <Tag color={t(`Admin.Appointment.consultationColor.${consultationState}`)} style={{ width: 'fit-content' }}>
          {t(`Admin.Appointment.consultation.${consultationState}`)}
        </Tag>
      }
    </>
  )
}

export default function StateTag ({ appointment, boxes }) {
  const box = boxes.find((e) => e.id === appointment.box_id)
  const isCurrentAppointment = appointment.id === box?.current_appointment?.id

  return (
    <Flex vertical>
      <AppointmentStateTag appointment={appointment} />
      {isCurrentAppointment && <BoxStateTag box={box} />}
      <ConsultationStateTag appointment={appointment} />
    </Flex>
  )
}
